import { FiCalendar, FiList } from "react-icons/fi";

function CalendarHeader({ activeView, setActiveView }) {
    return (
        <div className="event-view-switch" role="group" aria-label="Event view">
            <button onClick={() => setActiveView("list")} aria-pressed={activeView === "list"}>
                <FiList aria-hidden="true" /> List
            </button>
            <button onClick={() => setActiveView("calendar")} aria-pressed={activeView === "calendar"}>
                <FiCalendar aria-hidden="true" /> Calendar
            </button>
        </div>
    );
}

export default CalendarHeader;
